import React from 'react';
import { Icon } from './Icon.js';
export const IconTableCols2Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m5.25.5h-2C1.733.5.5,1.733.5,3.25v5.5c0,1.517,1.233,2.75,2.75,2.75h2V.5Z", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("path", { d: "m8.75.5h-2v11h2c1.517,0,2.75-1.233,2.75-2.75V3.25c0-1.517-1.233-2.75-2.75-2.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconTableCols2Fill12.js.map